import {
  DOMAIN_PREFIX,
  parentLanguageMap,
  urlPrefix,
} from '../../constants/staticPageConstants';

//TODO: Make this readable
export const processURL = (
  url: string,
  language: string,
  domain: number
): string => {
  if (domain) {
    const domainPrefix = DOMAIN_PREFIX[domain]?.host || '';
    const parentLanguage = parentLanguageMap[domainPrefix];
    if (language === 'Arabic') {
      let FINAL_URL = getStrippedURL(url);
      FINAL_URL = `ar/${FINAL_URL}`;
      return FINAL_URL;
    } else {
      if (language === parentLanguage) {
        return url;
      }
      return `${urlPrefix[language as keyof typeof urlPrefix]}/${url}`;
    }
  }
  return url;
};

const checkArabicURL = (url: string): boolean =>
  url.substring(url.length - 3) === '-ar';

export const getStrippedURL = (url: string): string => {
  if (checkArabicURL(url)) {
    return url.slice(0, -3);
  }
  return url;
};
